<div class="container-fluid width-box">
    <!-- Main Page Here -->
    <div class="row">
       <div class="col-md-12">
          <nav class="mt-2" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg
             xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
             <ol class="breadcrumb">
                <li class="breadcrumb-item">
                   <a href="/admin/settings">Settings</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">All</li>
             </ol>
          </nav>
          <div class="card  mt-5 mb-5">
             <div class="card-header d-flex">
                <div class="row col-12">
                   <div class="col-sm-12 col-md-5">
                      <h3 class="card-title">Account Details</h3>
                   </div>
                   <div class="col-sm-12 col-md-3  d-flex justify-content-end mr-2">
                   </div>
                   <div class="col-sm-12  col-md-4 d-flex justify-content-around">
                   </div>
                </div>
             </div>
             <div class="card-body">
                <div class="row setting-div" >
                   <div class="col-sm-6 col-md-4">
                      <label class="frm-label">Your Name</label>
                      <mat-form-field appearance="outline" class="full-width">
                         <input disabled type="text" matInput name="name" [value]=name>
                      </mat-form-field>
                   </div>
                   <div class="col-sm-6 col-md-4">
                      <label class="frm-label">Your Email</label>
                      <mat-form-field appearance="outline" class="full-width">
                         <input disabled type="text" matInput name="email" [value]=email>
                      </mat-form-field>
                   </div>
                   <div class="col-sm-6 col-md-4">
                      <label class="frm-label">Your Role</label>
                      <mat-form-field appearance="outline" class="full-width">
                         <input disabled type="text" matInput name="role" [value]=role>
                      </mat-form-field>
                   </div>
                </div>
                <div class="menu-box" data-ember-action="3904">
                </div>
             </div>
          </div>
          <div class="card  mt-5 mb-5">
             <div class="card-header d-flex">
                <div class="row col-12">
                   <div class="col-sm-12 col-md-5">
                      <h3 class="card-title">Account Settings</h3>
                   </div>
                   <div class="col-sm-12 col-md-3  d-flex justify-content-end mr-2">
                   </div>
                   <div class="col-sm-12  col-md-4 d-flex justify-content-around">
                   </div>
                </div>
             </div>
             <div class="card-body">
                <div class="row yoursetting-div" >
                   <div class="col-sm-6 col-md-4">
                      <div class="password-div" (click)="openchangepwd(changepwd)" >
                         <i-feather name="key"></i-feather>
                         Password Management
                         <p class="noshow">
                            Reset your password when you feel it is compromised
                         </p>
                      </div>
                   </div>
                   <div class="col-sm-6 col-md-4" *ngIf="!basicService.user_data.adminId">
                    <div class="password-div" (click)="showSMTPModal(smtpmodal)" >

                        <i-feather name="inbox"></i-feather>
                        SMTP Configuration
                        <span class="badge badge-pill badge-info" *ngIf="smtp_data.status"><i-feather class="checkedicon" name="check" ></i-feather></span>
                        <p class="noshow">
                           Set your email to read invoices from mentioned email inbox
                        </p>
                     </div>
                                            
                   </div>
                   <!-- <div class="col-sm-6 col-md-4">
                     <div class="password-div" (click)="showInvoiceModal(invpmodal)" >

                        <i-feather name="inbox"></i-feather>
                        Invoice Configuration
                        
                        <p class="noshow">
                           Set details of the Invoice
                        </p>
                     </div>                      
                   </div> -->
                </div>
                <div class="menu-box" data-ember-action="3904">
                </div>
             </div>
          </div>
          <!-- <div class="card  mt-5 mb-5" *ngIf="!basicService.user_data.adminId">
             <div class="card-header d-flex">
                <div class="row col-12">
                   <div class="col-sm-12 col-md-5">
                      <h3 class="card-title">Statistics</h3>
                   </div>
                   <div class="col-sm-12 col-md-3  d-flex justify-content-end mr-2">
                   </div>
                   <div class="col-sm-12  col-md-4 d-flex justify-content-around">
                   </div>
                </div>
             </div>
             <div class="card-body">
                <div class="row setting-div" >
                   <div class="col-sm-6 col-md-4">
                      <label class="frm-label">Total Invoices Uploaded</label>
                      <mat-form-field appearance="outline" class="full-width">
                         <input disabled type="text" matInput name="upload" [value]=totalInvoiceUploaded>
                      </mat-form-field>
                   </div>
                   <div class="col-sm-6 col-md-4">
                      <label class="frm-label">Total Invoices Accepted</label>
                      <mat-form-field appearance="outline" class="full-width">
                         <input disabled type="text" matInput name="accept" [value]=totalInvoiceAccepted>
                      </mat-form-field>
                   </div>
                   <div class="col-sm-6 col-md-4">
                      <label class="frm-label">Total Invoices Rejected</label>
                      <mat-form-field appearance="outline" class="full-width">
                         <input disabled type="text" matInput name="reject" [value]=totalInvoiceRejected>
                      </mat-form-field>
                   </div>
                </div>
             </div>
          </div> -->

          <!-- <div class="card  mt-5 mb-5" *ngIf="!basicService.user_data.adminId">
            <div class="card-header d-flex">
               <div class="row col-12">
                  <div class="col-sm-12 col-md-5">
                     <h3 class="card-title">API Settings</h3>
                  </div>
                  <div class="col-sm-12 col-md-3  d-flex justify-content-end mr-2">
                  </div>
                  <div class="col-sm-12  col-md-4 d-flex justify-content-around">
                  </div>
               </div>
            </div>
            <div class="card-body">
               <div class="row yoursetting-div" >
                  <div class="col-sm-6 col-md-4">
                     <div class="password-div"  (click)="showAPIKEYModal(apikeymodal)" >
                        <i-feather name="key"></i-feather>
                        API KEY
                        <p class="noshow">
                           Get API KEY to integrate API into your business
                        </p>
                     </div>
                  </div>
                  <div class="col-sm-6 col-md-4">
           
                  </div>
                  <div class="col-sm-6 col-md-4">
                  </div>
               </div>
               <div class="menu-box" data-ember-action="3904">
               </div>
            </div>
         </div>           -->
       </div>
       <!-- End Row -->
    </div>

    
    <ng-template #invpmodal let-modal>
      <div class="modal-header">
        <h6 class="modal-title">Invoice Details</h6>
        <button type="button" class="btn " aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form method="post" [formGroup]="invoiceForm" (ngSubmit)="onInvoiceSubmit()">
        <div class="modal-body">
           <div class="row" style="justify-content: center;align-items: center;display: flex;">
              <div class="col-sm-12 col-md-6">
               <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Enter GST Number</mat-label>
                  <input type="text" matInput placeholder="Enter GST Number" name="gstNum" formControlName="gstNum" >
                  <mat-error *ngIf="!invoiceForm.controls['gstNum'].valid && invoiceForm.controls['gstNum'].touched">Please enter GST Number</mat-error>
                </mat-form-field>
               </div>
                <div class="col-sm-12 col-md-6 p-3 justify-content-center d-flex">
                  <button type="button" class="btn ripple btn-primary" (click)="validateConfig()">Validate</button>
               </div>
           </div>   
           <div class="row">
               <div class="col-sm-12 col-md-12">
                  <mat-form-field appearance="outline" class="full-width">
                     <mat-label>Enter Vendor Name</mat-label>
                     <input type="text" matInput placeholder="Enter Vendor Name" name="vendorName" formControlName="vendorName" >
                     <mat-error *ngIf="!invoiceForm.controls['vendorName'].valid && invoiceForm.controls['vendorName'].touched">Please enter vendor name</mat-error>
                   </mat-form-field>
              </div>              
           </div> 
           
           <div  class="row" formArrayName="invoiceConfigDetails" *ngIf="invoiceConfigDetails.length>0">
               <div class="col-sm-12 col-md-12">
                  <div class="table-responsive tableFixHead">
                     <table class="table table-bordered border mb-0" >
                       <thead class="sticky-top">
                         <tr>
                           <th>#</th>                            
                           <th>Col Name</th>
                           <th>Display Name</th>
                           <th>Rows</th> 
                           <th>Cols</th> 
                           <th>Row in Col Pos</th>
                           <th>Col in Row Pos</th>
                         </tr>
                       </thead>
                       <tbody >
                         <tr *ngFor="let configDetails of invoiceConfigDetails.controls;index as i" [formGroupName]="i">
                           <td >
                             #{{i+1}}
                           </td>
                           <td  style="width: 40%;">
                              <input style="font-size: 12px;" type="text" formControlName="col_name" class="form-control iteminput" />
                              <mat-error *ngIf="!invoiceConfigDetails.controls[i].get('col_name')?.valid && invoiceConfigDetails.controls[i].get('col_name')?.touched">Please enter coloumn name</mat-error>
                           </td>
                           <td style="width: 40%;">
                              <input style="font-size: 12px;" type="text" formControlName="alias_name" class="form-control iteminput" /> 
                              <mat-error *ngIf="!invoiceConfigDetails.controls[i].get('alias_name')?.valid && invoiceConfigDetails.controls[i].get('alias_name')?.touched">Please enter display name</mat-error>
                           </td>
                           <td >
                              <input style="width: 50px;font-size: 12px;" formControlName="rows" type="text"  class="form-control iteminput" />
                              <mat-error *ngIf="!invoiceConfigDetails.controls[i].get('rows')?.valid && invoiceConfigDetails.controls[i].get('rows')?.touched">Please enter rows</mat-error>
                           </td>
                           <td>
                              <input style="width: 50px;font-size: 12px;" formControlName="cols" type="text"  class="form-control iteminput" /> 
                              <mat-error *ngIf="!invoiceConfigDetails.controls[i].get('cols')?.valid && invoiceConfigDetails.controls[i].get('cols')?.touched">Please enter coloumns</mat-error>
                           </td>
                           <td >
                              <input style="width: 50px;font-size: 12px;" formControlName="row_in_col_pos" type="text"  class="form-control iteminput" /> 
                              <mat-error *ngIf="!invoiceConfigDetails.controls[i].get('row_in_col_pos')?.valid && invoiceConfigDetails.controls[i].get('row_in_col_pos')?.touched">Please enter row in col pos</mat-error>
                           </td>  
                           <td >
                              <input style="width: 50px;font-size: 12px;" formControlName="col_in_row_pos" type="text"  class="form-control iteminput" /> 
                              <mat-error *ngIf="!invoiceConfigDetails.controls[i].get('col_in_row_pos')?.valid && invoiceConfigDetails.controls[i].get('col_in_row_pos')?.touched">Please enter col in row pos</mat-error>
                           </td>                                                                                 
                         </tr>
                       </tbody>
                     </table>
                   </div>
               </div>                          
           </div>
         </div>
         <mat-error *ngIf="!invoiceForm.controls['invoiceConfigDetails'].valid && invoiceForm.controls['invoiceConfigDetails'].touched">Please enter configuration details</mat-error>
         <div class="modal-footer">
            <button type="button" class="btn ripple btn-primary" (click)="deleteRow()">  <i-feather name="minus-circle"></i-feather>Delete Row</button>
            <button type="button" class="btn ripple btn-primary" (click)="addRow()"> <i-feather name="plus-circle"></i-feather>Add Row</button>                                                        
            <button type="submit" class="btn ripple btn-danger" >Save</button>
            <button type="button" class="btn ripple btn-secondary" (click)="modal.close('Save click')">Close</button>
         </div>
      </form>
    </ng-template>     
    <ng-template #smtpmodal let-modal>
      <div class="modal-header">
        <h6 class="modal-title">SMTP Details</h6>
        <button type="button" class="btn " aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form method="post" [formGroup]="smtpForm" (ngSubmit)="onSMTPSubmit()">
        <div class="modal-body">
           <div class="row">
              <div class="col-sm-12 col-md-6">
               <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Enter SMTP host</mat-label>
                  <input type="text" matInput placeholder="Enter SMTP Host" name="host" formControlName="host" (keypress)="onkeyPress($event)">
                  <mat-error *ngIf="!smtpForm.controls['host'].valid && smtpForm.controls['host'].touched">Please enter SMTP Host</mat-error>
                </mat-form-field>

              </div>
              <div class="col-sm-12 col-md-6">
               <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Enter SMTP Port</mat-label>
                  <input type="text" matInput placeholder="Enter Port" name="port" formControlName="port" (keypress)="onkeyPress($event)">
                  <mat-error *ngIf="!smtpForm.controls['port'].valid && smtpForm.controls['port'].touched">Please enter SMTP Port </mat-error>
                </mat-form-field>

              </div>
           </div>

           <div class="row">
            <div class="col-sm-12 col-md-6">
             <mat-form-field appearance="outline" class="full-width">
                <mat-label>Enter IMAP host</mat-label>
                <input type="text" matInput placeholder="Enter IMAP Host" name="imaphost" formControlName="imaphost" (keypress)="onkeyPress($event)">
                <mat-error *ngIf="!smtpForm.controls['imaphost'].valid && smtpForm.controls['imaphost'].touched">Please enter IMAP Host</mat-error>
              </mat-form-field>

            </div>
            <div class="col-sm-12 col-md-6">
             <mat-form-field appearance="outline" class="full-width">
                <mat-label>Enter IMAP Port</mat-label>
                <input type="text" matInput placeholder="Enter IMAP Port" name="imapport" formControlName="imapport" (keypress)="onkeyPress($event)">
                <mat-error *ngIf="!smtpForm.controls['imapport'].valid && smtpForm.controls['imapport'].touched">Please enter IMAP Port </mat-error>
              </mat-form-field>

            </div>
         </div>           
            <div class="row">
               <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="full-width">
                     <mat-label>Enter email</mat-label>
                     <input type="text" matInput placeholder="Enter email" name="login" formControlName="login" (keypress)="onkeyPress($event)">
                     <mat-error *ngIf="!smtpForm.controls['login'].valid && smtpForm.controls['login'].touched">Please enter email</mat-error>
                   </mat-form-field>
               </div>
               <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="full-width">
                     <mat-label>Enter Password</mat-label>
                     <input type="password" matInput placeholder="Enter Password" name="password" formControlName="password" (keypress)="onkeyPress($event)">
                     <mat-error *ngIf="!smtpForm.controls['password'].valid && smtpForm.controls['password'].touched">Please enter Password</mat-error>
                   </mat-form-field>
               </div>
            </div>  
            <div class="row">
               <div class="col-sm-12 col-md-6">
                  <mat-checkbox  formControlName="secure" (click)="onkeyPress($event)" >Use Secured Connection</mat-checkbox>
               </div>
               <div class="col-sm-12 col-md-6">
                     <mat-checkbox  formControlName="auth" [disabled]="true">Use authentication</mat-checkbox>
               </div>
            </div>   
            <div class="row">
               <div class="col-sm-12 p-3 justify-content-center d-flex">
                  <button type="submit" class="btn ripple btn-primary" (click)="testConnection($event)">Test Configuration</button>
               </div>
            </div>     
            <div class="row text-center" [hidden]="hideotp">
               <small>Please enter the OTP which is sent to same email mentioned above, to validate the email configuration.</small>
               <div class="col-sm-12 p-0 justify-content-center d-flex">
                  <input matInput type="text" class="digit" id="verificationCodeDigit1" formControlName="verificationCodeDigit1" minlength="1" maxlength="1" >
                  <input matInput type="text" class="digit" id="verificationCodeDigit2" formControlName="verificationCodeDigit2" minlength="1" maxlength="1" >
                  <input matInput type="text" class="digit" id="verificationCodeDigit3" formControlName="verificationCodeDigit3" minlength="1" maxlength="1" >
                  <input matInput type="text" class="digit" id="verificationCodeDigit4" formControlName="verificationCodeDigit4" minlength="1" maxlength="1" >
                  <input matInput type="text" class="digit" id="verificationCodeDigit5" formControlName="verificationCodeDigit5" minlength="1" maxlength="1" >
                  <input matInput type="text" class="digit" id="verificationCodeDigit6" formControlName="verificationCodeDigit6" minlength="1" maxlength="1" >
               </div>
            </div>                               
        </div>
        <div class="modal-footer">
          <button type="button" class="btn ripple btn-danger" [disabled]="disableSave" (click)="saveConnection($event)">Save</button>
          <button type="button" class="btn ripple btn-secondary" (click)="modal.close('Save click')">Close</button>
        </div>
      </form>
    </ng-template>    
    <ng-template #changepwd let-modal>
      <div class="modal-header">
        <h6 class="modal-title">Change Password</h6>
        <button [disabled]="!passwordSet" type="button" class="btn " aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form method="post" [formGroup]="passwordForm" (ngSubmit)="onSubmitPassword()">
        <div class="modal-body">
          <label class="frm-label">Old Password</label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Enter Old Password</mat-label>
            <input [readonly]="!passwordSet" type="password" matInput placeholder="Your Old Password" name="oldpwd" formControlName="oldpwd">
            <mat-error *ngIf="!passwordForm.controls['oldpwd'].valid && passwordForm.controls['oldpwd'].touched">Please enter old password</mat-error>
    
    
          </mat-form-field>
          <label class="frm-label">New Password</label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Enter New Password</mat-label>
            <input  matInput [type]="showPassword ? 'text' : 'password'"  matInput placeholder="Your New Password" name="newpwd" formControlName="newpwd">
            <mat-icon matSuffix  [hidden]="!showPassword" (click)="togglePasswordVisibility()">visibility</mat-icon>
            <mat-icon matSuffix [hidden]="showPassword" (click)="togglePasswordVisibility()">visibility_off</mat-icon>  
            <mat-error *ngIf="!passwordForm.controls['newpwd'].valid && passwordForm.controls['newpwd'].touched">Please enter new password</mat-error>
    
          </mat-form-field>      
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn ripple btn-primary" >Save</button>
          <button [disabled]="!passwordSet" type="button" class="btn ripple btn-secondary" (click)="modal.close('Save click')">Close</button>
        </div>
      </form>
    </ng-template>

    <ng-template #apikeymodal let-modal>
      <div class="modal-header">
        <h6 class="modal-title">API KEY</h6>
        <button type="button" class="btn " aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
        <div class="modal-body">
           <div class="row">
              <div class="col-12">
               <!-- <mat-form-field appearance="outline" class="full-width"> -->
                  <input [(ngModel)]="apiKey" disabled type="text" class="apikeyinput w-100" placeholder="APIKEY" name="host" >
                <!-- </mat-form-field> -->
                

              </div>

           </div>

           <div class="row justify-content-center">

            <div class="col-2 ">

                <div class="copy-text" [ngClass]="{'active': showtooltip}" >
                  <button class="btn ripple btn-primary"  data-toggle="tooltip" data-placement="top" (click)="copyapikeytoclipboard()"  [cdkCopyToClipboard]="apiKey" [cdkCopyToClipboardAttempts]="5" type="button"  tooltip="tooltiptext"><i-feather name="copy"></i-feather></button>
               </div>
                <!-- <div>
                  <span tooltip="tooltiptext" flow="down">Down</span>
                </div> -->

                <!-- <button  (click)="copyapikeytoclipboard()"  [cdkCopyToClipboard]="clipboardtext" mat-raised-button
                matTooltip="Copy to clipboard" aria-label="Button that displays a tooltip when focused or hovered over">
                <i-feather name="copy"></i-feather>
               </button> -->

                <!-- <button  type="button" class="btn ripple btn-primary" tooltip="Copy to clipboard"><i-feather name="copy"></i-feather></button> -->
              

            </div>
         </div>

         </div>
    </ng-template>        